export enum EarlyAccessFeatureStatus {
  PENDING = 'pending',
  ENABLED = 'enabled',
  DISABLED = 'disabled',
}
